var _g, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartlyCloudy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "rays",
    transformOrigin: "32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.6328 14.277C32.0332 14.5087 32.55 14.4003 32.8023 14.0126L33.7676 12.5292C34.0773 12.0533 33.9452 11.4147 33.4537 11.1303C32.9622 10.8459 32.3399 11.0481 32.0817 11.5539L31.2769 13.1301C31.0666 13.5421 31.2324 14.0453 31.6328 14.277Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6322 12.1356C24.0949 12.1356 24.4889 11.7825 24.5127 11.3205L24.604 9.55011C24.6332 8.98471 24.1983 8.5 23.6322 8.5C23.066 8.5 22.6312 8.98471 22.6603 9.55011L22.7516 11.3205C22.7755 11.7825 23.1695 12.1356 23.6322 12.1356Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6316 14.277C16.032 14.0453 16.1978 13.5421 15.9874 13.1301L15.1827 11.5539C14.9245 11.0481 14.3022 10.8459 13.8107 11.1303C13.3192 11.4147 13.1871 12.0533 13.4968 12.5292L14.462 14.0126C14.7144 14.4003 15.2312 14.5087 15.6316 14.277Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.77697 20.1316C10.0087 19.7312 9.90034 19.2144 9.51259 18.962L8.02925 17.9968C7.55329 17.6871 6.9147 17.8192 6.63028 18.3107C6.34585 18.8022 6.5481 19.4245 7.05386 19.6827L8.63007 20.4874C9.04209 20.6978 9.54526 20.532 9.77697 20.1316Z",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.82047 27.2516C7.28255 27.2755 7.63559 27.6695 7.63559 28.1322C7.63559 28.5949 7.28254 28.9889 6.82047 29.0127L5.05011 29.104C4.48471 29.1332 4 28.6983 4 28.1322C4 27.566 4.48471 27.1312 5.05011 27.1603L6.82047 27.2516Z",
    fill: "#FFD400"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 28,
    r: 12,
    fill: "#FFD400"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "cloud",
    d: "M17.8391 53.5575C11.0848 53.5575 5.60925 48.082 5.60925 41.3276C5.60925 34.5732 11.0848 29.0977 17.8391 29.0977C19.3037 29.0977 20.7081 29.3551 22.0096 29.8272C24.5775 23.5462 30.749 19.1207 37.9541 19.1207C47.4635 19.1207 55.1725 26.8296 55.1725 36.3391C55.1725 36.758 55.1575 37.1734 55.1281 37.5848C58.0038 38.909 60.0001 41.8162 60.0001 45.1897C60.0001 49.8111 56.2537 53.5575 51.6322 53.5575H17.8391Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartlyCloudy);
export default __webpack_public_path__ + "static/media/partlyCloudy.c9ba13e38983e12bd695642621d76bc8.svg";
export { ForwardRef as ReactComponent };